import * as login from './modules/login'
import * as menu from './modules/menu'
import * as listing from './modules/listing'
import * as sellercat from './modules/sellercat'
import * as check from './modules/check'
import * as item from './modules/item'
import * as traderate from './modules/traderate'
import * as stock from './modules/stock'
import * as user from './modules/user'
import * as syslog from './modules/syslog'
import * as sync from './modules/sync'
import * as sysparam from './modules/sysparam'
import * as content from './modules/content'
import * as admin from './modules/admin'
import * as cronjob from './modules/cronjob'
import * as userparam from './modules/userparam'

export default {
  login,
  menu,
  listing,
  sellercat,
  check,
  item,
  traderate,
  stock,
  user,
  syslog,
  sync,
  sysparam,
  content,
  admin,
  cronjob,
  userparam
}


// WEBPACK FOOTER //
// ./src/http/api.js